<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0" >
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>상세정보</v-tab>
          <v-tab>고장정보</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="pb-0"  cols="2">
        <v-select
          outlined
          solo
          dense
          hide-details
          @change="changeSubComp"
          :items="comboList"
          v-model="select"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs-items
          v-model="tabs"
        >
          <v-tab-item>
            <v-simple-table
              fixed-header
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center">RACK_STATUS</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_STATUS}}
                  </td>
                  <th class="text-center">RACK_DCCURRENT</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_DCCURRENT}}
                    <span class="tr-caption-style">A</span>
                  </td>
                  <th class="text-center">RACK_HIGHESTCELLV</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_HIGHESTCELLV}}
                    <span class="tr-caption-style">V</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_INFO1</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_INFO1}}
                  </td>
                  <th class="text-center">RACK_DCCHACURLIMIT</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_DCCHACURLIMIT}}
                    <span class="tr-caption-style">A</span>
                  </td>
                  <th class="text-center">RACK_LOWESTCELLV</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_LOWESTCELLV}}
                    <span class="tr-caption-style">V</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_INFO2</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_INFO2}}
                  </td>
                  <th class="text-center">RACK_DCDISCURLIMIT</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_DCDISCURLIMIT}}
                    <span class="tr-caption-style">A</span>
                  </td>
                  <th class="text-center">RACK_AVGMODTEMP</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_AVGMODTEMP}}
                    <span class="tr-caption-style">V</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_SOC</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_SOC}}
                    <span class="tr-caption-style">%</span>
                  </td>
                  <th class="text-center">RACK_DCCHAPOWERLIMIT</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_DCCHAPOWERLIMIT}}
                    <span class="tr-caption-style">kW</span>
                  </td>
                  <th class="text-center">RACK_HIGHESTMODTEMP</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_HIGHESTMODTEMP}}
                    <span class="tr-caption-style">℃</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_SOH</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_SOH}}
                    <span class="tr-caption-style">%</span>
                  </td>
                  <th class="text-center">RACK_DCDISPOWERLIMIT</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_DCDISPOWERLIMIT}}
                    <span class="tr-caption-style">kW</span>
                  </td>
                  <th class="text-center">RACK_LOWESTMODTEMP</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_LOWESTMODTEMP}}
                    <span class="tr-caption-style">℃</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_SOCV</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_SOCV}}
                    <span class="tr-caption-style">V</span>
                  </td>
                  <th class="text-center">RACK_CELLVLOCATION</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_CELLVLOCATION}}
                  </td>
                  <th class="text-center">RACK_MODULETEMPLOC</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_MODULETEMPLOC}}
                  </td>
                </tr>
                <tr>
                  <th class="text-center">RACK_AVGCELLV</th>
                  <td class="tr-value-style text-center">
                    {{RACK.RACK_AVGCELLV}}
                    <span class="tr-caption-style">V</span>
                  </td>
                </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <v-data-iterator
                :items="breakInfo"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:header>
                  <p>배터리 고장정보</p>
                  <p class="text-body-2">
                    고장정보 체크 시점일
                    <span class="pl-6 txt-blue">{{ nowDate }}</span>
                  </p>
                  <v-divider></v-divider>
                </template>
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.name"
                      cols="12"
                      sm="6"
                      md="6"
                      lg="3"
                    >
                      <v-card
                        width="450"
                        min-width="450"
                        style="background-color: inherit !important;"
                        class="elevation-0">
                        <v-card-title
                          class="text-subtitle-2 ">
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #d42a46"
                            v-if="item.condition"
                          ></div>
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #bdbdbd"
                            v-else
                          ></div>
                          <div>{{item.title}}</div>
                        </v-card-title>
                        <v-divider></v-divider>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import day from 'dayjs'

export default {
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      nowDate: day(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
      select: '',
      tabList: [
        { label: '상세정보', name: 'detail', isOn: true },
        { label: '고장정보', name: 'break', isOn: false }
      ],
      itemsPerPage: 50,
      item: [],
      essResult: [],
      RACK: {}
    }
  },
  watch: {
    essData() {
      this.initData()
    },
    comboList() {
      this.select = this.comboList[0].value
    }
  },
  mounted: function() {
    this.initData()
  },
  computed: {
    comboList() {
      let list = []
      for (let item of this.essResult) {
        if (item.photo === 'RACK') {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      return list
    },
    breakInfo() {
      return [
        {
          title: 'Over Charge Current Warning',
          condition: this.RACK.RACK_WARNINGCODE === '1.0'
        },
        {
          title: 'Over Discharge Current Warning',
          condition: this.RACK.RACK_WARNINGCODE === '2.0'
        },
        {
          title: 'Over Charge Power Limit Warning',
          condition: this.RACK.RACK_WARNINGCODE === '4.0'
        },
        {
          title: 'Over Discharge Power Limit Warning',
          condition: this.RACK.RACK_WARNINGCODE === '8.0'
        },
        {
          title: 'Over Cell Voltage Warning',
          condition: this.RACK.RACK_WARNINGCODE === '16.0'
        },
        {
          title: 'Under Cell Voltage Warning',
          condition: this.RACK.RACK_WARNINGCODE === '32.0'
        },
        {
          title: 'Over Cell Voltage Difference Warning',
          condition: this.RACK.RACK_WARNINGCODE === '64.0'
        },
        {
          title: 'Over Module Temperature Warning',
          condition: this.RACK.RACK_WARNINGCODE === '128.0'
        },
        {
          title: 'Under Module Temperature Warning',
          condition: this.RACK.RACK_WARNINGCODE === '256.0'
        },
        {
          title: 'Over Module Temperature Difference Warning',
          condition: this.RACK.RACK_WARNINGCODE === '512.0'
        },
        {
          title: 'Over Charge Current Fault',
          condition: this.RACK.RACK_FAULTCODE === '1.0'
        },
        {
          title: 'Over Discharge Current Fault',
          condition: this.RACK.RACK_FAULTCODE === '2.0'
        },
        {
          title: 'Over Charge Power Limit Fault',
          condition: this.RACK.RACK_FAULTCODE === '4.0'
        },
        {
          title: 'Over Discharge Power Limit Fault',
          condition: this.RACK.RACK_FAULTCODE === '8.0'
        },
        {
          title: 'Over Cell Voltage Fault',
          condition: this.RACK.RACK_FAULTCODE === '16.0'
        },
        {
          title: 'Under Cell Voltage Fault',
          condition: this.RACK.RACK_FAULTCODE === '32.0'
        },
        {
          title: 'Over Cell Voltage Difference Fault',
          condition: this.RACK.RACK_FAULTCODE === '64.0'
        },
        {
          title: 'Over Module Temperature Fault',
          condition: this.RACK.RACK_FAULTCODE === '128.0'
        },
        {
          title: 'Under Module Temperature Fault',
          condition: this.RACK.RACK_FAULTCODE === '256.0'
        },
        {
          title: 'Over Module Temperature Difference Fault',
          condition: this.RACK.RACK_FAULTCODE === '512.0'
        },
        {
          title: 'Comm. Error with the RACK',
          condition: this.RACK.RACK_OTHERFAULTCODE === '1.0'
        },
        {
          title: 'Comm. Error with MBMSs',
          condition: this.RACK.RACK_OTHERFAULTCODE === '2.0'
        },
        {
          title: 'Current Sensing Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '4.0'
        },
        {
          title: 'Temperature Sensing Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '8.0'
        },
        {
          title: 'Rack Unbalancing Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '16.0'
        },
        {
          title: 'Disconnect Switch Feedback Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '32.0'
        },
        {
          title: 'Main Contactor Feedback Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '64.0'
        },
        {
          title: 'Fan Feedback Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '128.0'
        },
        {
          title: 'MBMS OBD Error',
          condition: this.RACK.RACK_OTHERFAULTCODE === '256.0'
        },
        {
          title: 'Rack Connection Fault',
          condition: this.RACK.RACK_OTHERFAULTCODE === '512.0'
        },
        {
          title: 'Initialization Fault',
          condition: this.RACK.RACK_OTHERFAULTCODE === '1024.0'
        },
        {
          title: 'Contactor Open Fault',
          condition: this.RACK.RACK_OTHERFAULTCODE === '2048.0'
        }
      ]
    }
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.item = this.essData
        this.essResult = this.item.essResult

        if (this.item.essData.filter(d => d.RACK).length !== 0) {
          this.RACK = this.item.essData.filter(d => d.RACK)[0].RACK
        }
      }
    },
    changeSubComp(e) {
      let codeID = e
      this.RACK = this.item.essData
        .filter(d => d.RACK)
        .filter(d => d.RACK.RACK_CODEID === codeID)[0].RACK
      console.log(this.RACK)
    },
    changeTab(key) {
      $("span[name='sub_tab_pcs']").removeClass('on')
      $('#tab_pcs_' + key).addClass('on')

      $("div[name='pcs_tab']").removeClass('on')
      $('#pcs_' + key).addClass('on')
    }
  }
}
</script>

<style lang="less" scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  /*background-color: var(--v-hth-base);*/
  background-color: var(--v-hth-base);
  border: thin solid var(--v-hthline-base);
  color: var(--v-hthtext-base);
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  border: thin solid var(--v-hthline-base);
}
</style>
